module.exports = __webpack_public_path__ + "static/homedelegate.19159309.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/img/homedelegate.png
// module id = ./src/pages/about/img/homedelegate.png
// module chunks = 116195567845805